import { DocumentNode } from "graphql";
import { BaseModel } from "../data/model/Base";
import { PageQueryOptions } from "./page-query";

export type BaseEntityType = {
  id: string | number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt?: Date;
};

export interface EntityResourceDefinitionConfig<
  T extends BaseEntityType,
  J extends BaseModel
> {
  entity: string;
  query: DocumentNode;
  prepareEntity: (record: J, fetchedEntity: T) => void;
  fetchEntities: (options?: PageQueryOptions) => Promise<T[]>;
}

export class EntityResourceDefinition<
  T extends {
    id: string | number;
    createdAt: Date;
    updatedAt: Date;
    deletedAt?: Date;
  },
  J extends BaseModel
> {
  constructor(public config: EntityResourceDefinitionConfig<T, J>) {}
}
